
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 18h12l.5 14h-13l.5-14z","fill":"#fff"}}),_c('path',{attrs:{"d":"M21.752 17.499V7.745A3.752 3.752 0 0018 3.993v0a3.752 3.752 0 00-3.752 3.752v9.754","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill":"#F1C013","d":"M15 8h6v9h-6z"}}),_c('path',{attrs:{"d":"M11.247 17.5h13.506M31.506 32.505H4.494M18 32.505v-3.001M18 32.505v-3.001M31.506 8.996l-3.002.75M28.504 14.248l3.002.75M4.494 14.998l3.002-.75M7.496 9.747l-3.002-.75M23.504 8.75H13M24.003 17.499l.75 15.006M11.998 17.499l-.75 15.006","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    